/**
 * De tegenstanders die het opzetscherm aanbiedt.
 *
 * Naam, portret en de beschrijving die de cd erbij toont. Gegenereerd door
 * `tools/extract-karakters.ts` uit `text/Characters.txt`; overtypen zou fouten
 * introduceren in teksten die niemand nog kan controleren.
 */
import { z } from 'zod';
import data from './data/karakters.json' with { type: 'json' };

export const KarakterSchema = z
  .object({
    naam: z.string().min(1),
    beschrijving: z.string().min(1),
    /** De sleutel in de assetgroep `portretten`. */
    portret: z.string().min(1),
  })
  .strict();

export type Karakter = z.infer<typeof KarakterSchema>;

export const KARAKTERS: readonly Karakter[] = z
  .array(KarakterSchema)
  .parse((data as { karakters: unknown[] }).karakters);
